import s3Api from "../api/s3";
import axios from "axios";
import store from "../store";

class UploadFiles {
    constructor() {
        this.uploadSession = {
            file: "",
            fileName: "",
            fileSize: 0,
            successfullyUploaded: 0,
            uploadUri: undefined,
            uploadFields: undefined,
            type: "",
            clientId: ""
        };
    }

    async init(buffer, file, type, clientId) {
        this.uploadSession.file = file;
        this.uploadSession.fileName = file.name;
        this.uploadSession.fileSize = file.slice().size;
        this.uploadSession.type = type;
        this.uploadSession.clientId = clientId;

        // Reset progress value
        store.commit("set", ["importProgress", 0]);

        const { url: presignedUrl, fields } = await this.getPresignedUrl();
        return await this.uploadToS3(presignedUrl, fields, file);
    }

    async getPresignedUrl() {
        try {
            const res = await s3Api.getPresignedUrl({
                fileName: this.uploadSession.fileName,
                type: this.uploadSession.type,
                clientId: this.uploadSession.clientId
            });
            return JSON.parse(res.data.body);
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async uploadToS3(presignedUrl, fields, file) {
        // Preparing the payload to upload in s3
        const formData = new FormData();

        Object.keys(fields).forEach(key => {
            formData.append(key, fields[key]);
        });
        formData.append("file", file);

        // Upload the file to s3
        try {
            const s3UploadRes = await axios.post(presignedUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                onUploadProgress: function (progressEvent) {
                    store.commit("set", [
                        "importProgress",
                        parseInt(
                            Math.round(
                                (progressEvent.loaded / progressEvent.total) *
                                100
                            )
                        )
                    ]);
                }.bind(this)
            });
            if (s3UploadRes) {
                console.log("file upload successfully!!");
                return true;
            } else {
                console.log("failed to upload the file");
                return false;
            }
        } catch (err) {
            console.log(err);
            return false;
        }
    }
}

export default UploadFiles;
